import { render, staticRenderFns } from "./area-key.component.vue?vue&type=template&id=9934b8f2&scoped=true&"
import script from "./area-key.component.vue?vue&type=script&lang=ts&"
export * from "./area-key.component.vue?vue&type=script&lang=ts&"
import style0 from "./area-key.component.vue?vue&type=style&index=0&id=9934b8f2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9934b8f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VExpandTransition,VIcon,VRow,VTextField})
